import { render, staticRenderFns } from "./VeJwSelectStudent.vue?vue&type=template&id=128ccebe&scoped=true"
import script from "./VeJwSelectStudent.vue?vue&type=script&lang=js"
export * from "./VeJwSelectStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ccebe",
  null
  
)

export default component.exports